export default {
  drawerTitle: {
    id: 'back_market_promise_drawer_dialog_title',
    defaultMessage: 'Perks with your purchase',
  },
  perksTitle: {
    id: 'back_market_promise_drawer_perks_title',
    defaultMessage: 'Coverred the moment it arrives',
  },
  perk1title: {
    id: 'back_market_promise_drawer_perk1_title',
    defaultMessage: 'Free 1-year warranty',
  },
  perk1description: {
    id: 'back_market_promise_drawer_perk1_description',
    defaultMessage:
      "Every order comes with a free 1-year warranty covering repairs, exchanges, or refunds, and we'll cover your shipping too.",
  },
  perk2title: {
    id: 'back_market_promise_drawer_perk2_title',
    defaultMessage: 'Free 30-day returns',
  },
  perk2description: {
    id: 'back_market_promise_drawer_perk2_description',
    defaultMessage:
      "Didn’t work out for you? Return your device within 30 days and we'll take care of the shipping.",
  },
  perk3title: {
    id: 'back_market_promise_drawer_perk3_title',
    defaultMessage: 'Real customer care',
  },
  perk3description: {
    id: 'back_market_promise_drawer_perk3_description',
    defaultMessage:
      'Talk to a real person and get support on any issue that comes up with your order.',
  },
}
